import report from './index';

export default { path: '/home/report', component: report };
